export enum OnlineOrderingConfigurationGroupEnum {
  storeInfo = 'Store Info',
  storeImage = 'Store Image',
  fulfilmentOptions = 'Fulfilment Options'
 }
